import useAxios from 'hooks/useAxios';

export async function deleteItem(id) {
  const api = useAxios();

  try {
    const res = await api.delete(`/items/${id}`);
    return res;
  } catch (err) {
    return err;
  }
}
